/* eslint id-length: [2, {"exceptions":["a","b"]}] */

/**
 * Geography columns are hard, here are a bunch of special cases to sort through/for
 */
import { buildRowProperties } from './util';
import { appDefault } from '../../config/config';

export default function geoSorter(
  a, b, column, isInverted, aBase, bBase, aIsSummary, bIsSummary) {
  const aProps = buildRowProperties(a, column);
  const bProps = buildRowProperties(b, column);

  // @TODO - remove the unneeded multiplication here
  // @TODO - not a bad idea to revisit this sorter and the others

  aProps.isSummary = aIsSummary;
  bProps.isSummary = bIsSummary;

  // Wrapups pushed to the top
  if (aProps.wrapup && bProps.wrapup) {
    return appDefault.specialWrapups.indexOf(a) -
      appDefault.specialWrapups.indexOf(b);
  } else if (aProps.wrapup && !bProps.wrapup) {
    return isInverted ? 1 : -1;
  } else if (!aProps.wrapup && bProps.wrapup) {
    return isInverted ? -1 : 1;
  }

  if (a.indexOf('MA Region') > -1 && b.indexOf('MA Region') > -1) {
    return parseInt(a.split(' ')[2], 10) - parseInt(b.split(' ')[2], 10);
  }

  // For special (numbered) geos, sort by the numerical value in the characteristic
  if (aProps.isSpecialGeo && bProps.isSpecialGeo) {
    const anum = parseInt(a.replace(/^\D+/g, ''), 10);
    const bnum = parseInt(b.replace(/^\D+/g, ''), 10);
    return anum - bnum;
  } else if (aProps.isSpecialGeo && !bProps.isSpecialGeo) {
    return isInverted ? -1 : 1;
  } else if (bProps.isSpecialGeo && !aProps.isSpecialGeo) {
    return isInverted ? 1 : -1;
  }

  // State categories (All Rural Counties, etc) pushed to the top
  if (aProps.isStateCategory && !bProps.isStateCategory) {
    return (isInverted ? 1 : -1) * 1;
  } else if (bProps.isStateCategory && !aProps.isStateCategory) {
    return (isInverted ? 1 : -1) * 1;
  // Territories pushed to the bottom, only in US context
  } else if (aProps.isTerritory &&
    bProps.isTerritory) {
    return aProps.value.localeCompare(bProps.value);
  } else if (aProps.isTerritory &&
    !bProps.isTerritory) {
    return (isInverted ? -1 : 1) * 1;
  } else if (bProps.isTerritory &&
    !aProps.isTerritory) {
    return (isInverted ? -1 : 1) * -1;
  }

  // Summary rows float up without matching groups
  const aClippedValue = aProps.value.replace(appDefault.isSummaryRow, '');
  const bClippedValue = bProps.value.replace(appDefault.isSummaryRow, '');
  if (aClippedValue === bClippedValue && aProps.isSummary) {
    return (isInverted ? -1 : 1) * -1;
  } else if (aClippedValue === bClippedValue && bProps.isSummary) {
    return (isInverted ? 1 : -1) * -1;
  } else if (aClippedValue === bClippedValue) {
    return (isInverted ? -1 : 1) * aBase.localeCompare(bBase);
  }

  return aProps.value.localeCompare(bProps.value);
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/util/sorters/geoSort.js
 **/